module.exports = __webpack_public_path__ + "static/img/08.0147d825.png";